"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateAgoraVideoDeviceListeners = void 0;
var _setupDeviceListeners = require("@cvent/studio-agora/events/setupDeviceListeners");
var _setAttendeeCameraStatus = _interopRequireDefault(require("../actions/attendee/setAttendeeCameraStatus"));
var _addToAttendeeTiles = _interopRequireDefault(require("../actions/meeting/addToAttendeeTiles"));
var _setVideoInputDevice = _interopRequireDefault(require("../actions/meeting/setVideoInputDevice"));
var _showNotification = _interopRequireDefault(require("../actions/notification/showNotification"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Sets up listeners for Agora video device changes and dispatches appropriate actions to update the Redux store.
 * @param videoInput
 * @param dispatch
 * @param attendeeId
 */
var updateAgoraVideoDeviceListeners = exports.updateAgoraVideoDeviceListeners = function updateAgoraVideoDeviceListeners(videoInput, dispatch, attendeeId, client) {
  var videoActions = {
    showNotification: _showNotification["default"],
    addToAttendeeTiles: _addToAttendeeTiles["default"],
    setAttendeeCameraStatus: _setAttendeeCameraStatus["default"],
    setVideoInputDevice: _setVideoInputDevice["default"]
  };
  (0, _setupDeviceListeners.clearVideoDeviceListeners)();
  (0, _setupDeviceListeners.setupVideoDeviceListeners)(videoInput, dispatch, videoActions, attendeeId, client);
};